import {
  getFromLocalStorage,
  LOCAL_STORAGE_KEYS,
  removeFromLocalStorage,
  setInLocalStorage,
} from '@/shared/utils/localStorageUtils';

export type TabEligibility = {
  shouldHideBilling: boolean;
  shouldHidePlans: boolean;
  shouldHideNotifications: boolean;
};

export function getCachedTabEligibility(): TabEligibility | null {
  try {
    const cached = getFromLocalStorage<TabEligibility>(
      LOCAL_STORAGE_KEYS.ACCOUNT_SETTINGS_TAB_ELIGIBILITY,
      true,
    );

    return cached;
  } catch {
    removeFromLocalStorage(
      LOCAL_STORAGE_KEYS.ACCOUNT_SETTINGS_TAB_ELIGIBILITY,
      true,
    );
    return null;
  }
}

export function setCachedTabEligibility(eligibility: TabEligibility): void {
  setInLocalStorage(
    LOCAL_STORAGE_KEYS.ACCOUNT_SETTINGS_TAB_ELIGIBILITY,
    eligibility,
    true,
  );
}

export function clearCachedTabEligibility(): void {
  removeFromLocalStorage(
    LOCAL_STORAGE_KEYS.ACCOUNT_SETTINGS_TAB_ELIGIBILITY,
    true,
  );
}
